import React, { useEffect, useState } from 'react';
import { Components } from './styled';
import ProjectModal from '../../ProjectModal';
import { ModalOptionType } from './types';
import { SMALL_PROJECT_MODAL_WIDTH } from '../../../utils/styled/dimensions';

const ModalBody = ({
  modalRadioState,
  options,
  onOptionCheck,
}: {
  modalRadioState: string | undefined;
  options: ModalOptionType[];
  onOptionCheck: (value: string) => void;
}) => {
  return (
    <Components.ModalBodyContainer>
      {options &&
        options.length > 0 &&
        options?.map((item, key) => (
          <Components.RadioItemContainer
            key={key}
            isChecked={modalRadioState === item.value}
            onClick={() => onOptionCheck(item.value)}>
            <Components.RadioItemLabel>{item.label}</Components.RadioItemLabel>
            <Components.RadioItemCheckbox checked={modalRadioState === item.value} />
          </Components.RadioItemContainer>
        ))}
    </Components.ModalBodyContainer>
  );
};

const ModalButtons = ({
  onModalClose,
  onContinue,
  isContinueButtonDisabled,
}: {
  onModalClose: () => void;
  onContinue: () => void;
  isContinueButtonDisabled: boolean;
}) => {
  return (
    <Components.ModalButtonsContainer>
      <Components.CancelButton onClick={onModalClose}>Cancel</Components.CancelButton>
      <Components.Button onClick={onContinue} isDisabled={isContinueButtonDisabled}>
        Next
      </Components.Button>
    </Components.ModalButtonsContainer>
  );
};

const SelectOptionModal = ({
  modalTitle,
  options,
  onContinue,
  isModalOpen,
  onModalClose,
}: {
  modalTitle: string;
  options: ModalOptionType[];
  isModalOpen: boolean;
  onContinue: (modalRadioState: string | undefined) => void;
  onModalClose: () => void;
}) => {
  const [modalRadioState, setModalRadioState] = useState<string | undefined>(undefined);

  useEffect(() => {
    setModalRadioState(undefined);
  }, [isModalOpen]);

  const onOptionCheck = (value: string) => {
    setModalRadioState(value);
  };

  const _onModalClose = () => {
    onModalClose?.();
  };
  const _onContinue = () => {
    onContinue?.(modalRadioState);
  };

  return (
    <ProjectModal
      bodyChildren={<ModalBody modalRadioState={modalRadioState} options={options} onOptionCheck={onOptionCheck} />}
      buttonChildren={
        <ModalButtons
          onModalClose={_onModalClose}
          onContinue={_onContinue}
          isContinueButtonDisabled={modalRadioState === undefined}
        />
      }
      isModalOpen={isModalOpen}
      onModalClose={_onModalClose}
      modalTitle={modalTitle}
      modalWidth={SMALL_PROJECT_MODAL_WIDTH}
      disableCloseOnClickAway
    />
  );
};

export default SelectOptionModal;
